<template>
  <div class="errPage-container">
    <img src="/static/imgs/401.png" width="145" height="142" alt="Girl has dropped her ice cream.">
    <div class="mt10" style="font-size: 16px;">{{$t('非常抱歉，您目前使用的是免费版本，暂不支持此功能。')}}</div>
    <div class="mt20">{{$t('如想升级服务，请联系我们的服务人员')}}：0731-89921796 
    </div>
  </div>
</template>

<script>
	import { mapGetters } from 'vuex'
	
	export default {
	  name: 'page401',
    props:["name"],
	  data() {
	    return {
	    	moduleName:''
	    }
	  },
	  computed: {
	    ...mapGetters([
	      'routerKeyData'
	    ])
	  },
	  watch:{
	  	"$route"(){
	  		this.moduleName = this.$route.query.redirect
	  	},
      name(){
	  	  if(this.$route.query.redirect){
	  	    this.moduleName = this.$route.query.redirect
        }else{
	  	    this.moduleName = this.name
        }
      }
	  },
	  created(){
      if(this.$route.query.redirect){
        this.moduleName = this.$route.query.redirect
      }else{
        this.moduleName = this.name
      }
	  },
	  methods: {
	    back() {
	      if (this.$route.query.noGoBack) {
	        this.$router.push({ path: '/login' })
	      } else {
	        this.$router.go(-1)
	      }
	    }
	  }
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .errPage-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>
